import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=2698c4bb&scoped=true"
import script from "./Full.vue?vue&type=script&lang=js"
export * from "./Full.vue?vue&type=script&lang=js"
import style0 from "./Full.vue?vue&type=style&index=0&id=2698c4bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2698c4bb",
  null
  
)

export default component.exports